import { observable } from "mobx";
import { Type } from "class-transformer";
import ExemptionRegistrationMethod from "./exemptionRegistrationMethod";
import VehicleRegisterSynchronizationStatus from "./vehicleRegisterSynchronizationStatus";
import VehicleResponse from "./vehicleResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionDetailResponse {
  /**
   * Exemption ID.
   */
  @observable
  exemptionId!: string;

  @observable
  @Type(() => VehicleResponse)
  vehicle!: VehicleResponse;

  /**
   * Exemption reason ID.
   */
  @observable
  exemptionReasonId!: string;

  /**
   * Creation record ID.
   */
  @observable
  creationRecordId?: string;

  @observable
  creationMethod!: ExemptionRegistrationMethod;

  /**
   * Exemption was created at this date and time.
   */
  @observable
  @Type(() => Date)
  createdAt!: Date;

  /**
   * Created by.
   */
  @observable
  createdBy?: string;

  /**
   * Cancellation official record ID.
   */
  @observable
  cancellationRecordId?: string;

  @observable
  cancellationMethod?: ExemptionRegistrationMethod;

  /**
   * Cancellation reason.
   */
  @observable
  cancellationReason?: string;

  /**
   * Vehicle registration change official record ID.
   */
  @observable
  vehicleRegistrationChangeRecordId?: string;

  /**
   * Exemption is valid since this date and time.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * Exemption is valid until this date and time.
   */
  @observable
  @Type(() => Date)
  validUntil?: Date;

  @observable
  vehicleRegisterSynchronizationStatus!: VehicleRegisterSynchronizationStatus;
}
